export type AuthProvider = 'auth0' | 'better-auth'
export type AuthSelection = AuthProvider | 'signed-out' | null

const STORAGE_KEY = 'portal.auth.provider'
let inMemorySelection: AuthSelection = null

export function readAuthSelection(): AuthSelection {
  let value: string | null
  try {
    value = sessionStorage.getItem(STORAGE_KEY)
    if (value === null) return inMemorySelection
  } catch {
    return inMemorySelection
  }
  return value === 'auth0' || value === 'better-auth' || value === 'signed-out'
    ? value
    : null
}

/** Remember explicit provider choice across redirects and reloads in this tab. */
export function selectAuthProvider(provider: AuthSelection) {
  inMemorySelection = provider
  try {
    if (provider === null) sessionStorage.removeItem(STORAGE_KEY)
    else sessionStorage.setItem(STORAGE_KEY, provider)
  } catch {
    // A browser that disables storage can still sign in within this page.
  }
}
